import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useCreateDatasetNotification = (event) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.CREATE_DATASET_NOTIFICATION, event }), [event]);
};

const useUpdateDatasetNotificationCreateProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_DATASET_NOTIFICATION_CREATE_PROPERTIES, properties,
  }), []);
};

const useShowDatasetNotificationCreate = ({ code }) => {
  const handler = useDispatch();
  return useCallback(({ name }) => handler({
    type: actions.SHOW_DATASET_NOTIFICATION_CREATE, code, name,
  }), [code]);
};

export default {
  useCreateDatasetNotification,
  useHideDatasetNotificationCreate: () => Events.useSimpleDispatch(actions.HIDE_DATASET_NOTIFICATION_CREATE),
  useShowDatasetNotificationCreate,
  useUpdateDatasetNotificationCreateProperties,
};
